export default "__VITE_ASSET__DaYzoFp7__"